import React from "react";

import { Button, Modal } from "antd";

import "./ConfirmationModal.css";

export default function ConfirmationModal({
  headerText,
  bodyText,
  buttonText, // [0: cancel, 1: submit, 2: submit-loading]
  buttonFunctions, // [0: cancel, 1: submit, 2: submit-loading]
  loading,
  width,
  className,
  renderExtraContent,
}) {
  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      destroyOnClose
      footer={null}
      width={width ?? "520px"}
      wrapClassName={className ? `ConfirmationModal ${className}` : "ConfirmationModal"}
    >
      <div className="ConfirmationModal__">
        <div className="ConfirmationModal__Title">{headerText}</div>
        <div className="ConfirmationModal__TitleMessage">{bodyText}</div>
        {renderExtraContent && (
          <div className="ConfirmationModal__TitleMessage__extra">
            {renderExtraContent}
          </div>
        )}
        <div className="ConfirmationModal__Btn">
          <Button
            htmlType="button"
            type="default"
            onClick={buttonFunctions[0]}
            disabled={loading}
          >
            {buttonText[0]}
          </Button>
          <Button
            htmlType="button"
            type="primary"
            onClick={buttonFunctions[1]}
            loading={loading}
          >
            {loading ? buttonText[2] : buttonText[1]}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
